var cilNoteAdd = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M24,24V496H318.627L496,318.627V24ZM56,56H464V272H272V464H56ZM305.373,464H304V304H464v1.373Z' class='ci-primary'/><polygon fill='var(--ci-primary-color, currentColor)' points='208 288 208 208 288 208 288 176 208 176 208 96 176 96 176 176 96 176 96 208 176 208 176 288 208 288' class='ci-primary'/>"];

export { cilNoteAdd };

